import { render, staticRenderFns } from "./KitCompare.vue?vue&type=template&id=0aab4f2e"
import script from "./KitCompare.vue?vue&type=script&lang=js"
export * from "./KitCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports